<template>
  <div class="search-header">
    <van-search
        v-model="value"
        show-action
        :placeholder="keyName"
        @search="onSearch"
        @cancel="onCancel"
      />
    <!-- <img class="filter" src="@/assets/imgs/product_filter.png" @click="onFilter" /> -->
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      value: '',
    };
  },
  props: {
    keyName: String,
  },
  computed: {},
  methods: {
    onFilter() {
      this.$emit("onFilter");
    },
    onSearch() {
      this.$emit("onSearch", this.value);
    },
    onCancel() {
    this.value="";
     this.$emit("onCancel", this.value);
    },
  }
};
</script>

<style lang="stylus" scoped>
.search-header >>> .van-search {
  width 90%
}
.search-header >>> .van-field__control, .search-header >>> .van-field__left-icon {
   height: 40px; 
   line-height: 40px;
}
.search-header
  height 88px
  background rgba(244, 244, 244, 1)
  padding 0 22px 0 34px
  display flex
  justify-content flex-start
  align-items center
  .center
    font-size 36px
    font-weight 600
    color rgba(34, 34, 34, 1)
    flex 1
    text-align center
  .back
    width 24.83px
    height 45.66px
  .filter
    width 40px
    height 40px
</style>
